import saveAs from "file-saver";
import { APISettings } from "../../../../../../config/ApiSettings";
import { chapterHistoryApi } from "../../../../../../utilities/api/chapterHistoryApi";
import { RecordStatuses } from "../../../../../../utilities/enums/RecordStatuses";
import { useEffect, useState } from "react";

export const useChapterHistoryTableController = (chapter: any) => {

  const baseUrl = new APISettings().getApiURL();

  const downloadPdf = async (containerName: string, blobName: string) => {
    let url = `${baseUrl}/fileStorage/GetAsByteArray/${containerName}/${blobName}`;
    let blob: Blob = await fetch(url).then((r) => r.blob());

    saveAs(blob, blobName);
  }

  const [historyItems, setHistoryItems] = useState<any[]>([]);

  useEffect(() => {
    getHistoryItems();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getHistoryItems = async () => {
    let results = await chapterHistoryApi.getChapterHistoriesByChapterId(chapter?.id);
    results.push({
      effectiveFrom: chapter.effectiveDate,
      recordStatusId: RecordStatuses.New
    });
    setHistoryItems(results);
  }


  return {
    historyItems,
    downloadPdf,
  };
};